import React from "react";
import { useSelector } from "react-redux";

const NotOK = (props: any) => {

  // TODO: take props
  const handleClose = props.handleClose;

  // TODO: redux
  const data = useSelector((state: any) => state.appReducer.data)

  return (
    <div className="flex flex-col w-full h-max">
      {/* title */}
      <div className="flex justify-between text-white pl-3 pr-3 items-center w-full h-[2.5rem] bg-rose-600 rounded-t-md">
        <p>Chưa hoàn tất 20 câu hỏi</p>
      </div>

      {/* content */}
      <div className="flex flex-col w-full h-max p-3">
        <p>Chào {data.name},</p>
        <p>Bạn vẫn chưa hoàn tất 20 câu hỏi.</p> <br />
        <p>Vui lòng <strong>hoàn thành</strong> "Các câu còn trống" để tiếp tục. Cảm ơn {data.name}.</p> <br />
        <p>Các câu còn trống:</p>
        <div className="flex w-full h-max overflow-clip">
          {data.isntResult.map((item: any, index: any) => {
            return (
              <span key={index}>{item},&nbsp;</span>
            )
          })}
        </div>
        <div className="flex mt-7 justify-end items-center w-full h-max">
          <button onClick={handleClose} className="flex rounded-md justify-center items-center w-[5rem] h-[1.75rem] bg-slate-300 hover:bg-slate-200">
            Đóng
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotOK;
